import {ControllerEventName} from "../../../event-buses/ControllerEventName";

export class NavigatorBarControllerEventName extends ControllerEventName {

  static readonly NavigatorBarItems = 'NavigatorBarItems';
  static readonly NavigatorBarItemSelected = 'NavigatorBarItemSelected';
}
